module.exports = __webpack_public_path__ + "img/1230.18a1e8f1.jpg";